/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */

import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  useAsyncDebounce,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Autocomplete from "@mui/material/Autocomplete";
import Icon from "@mui/material/Icon";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import MDTypography from "components/MDTypography";
import { Card, Grid, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { Link } from "react-router-dom";
import "./tableStyle.css";
function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  addNew,
  customAdd,
  table,
  pagination,
  isSorted,
  noEndBorder,
  screenName,
  link,
  Header,
  AddorSort,
  selectedValue,
  newSelectedValue,
}) {
  const defaultValue = 10;
  const entries = ["10"];
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // Set the default value for the entries per page when component mounts
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

  // Set the entries per page value based on the select value
  const setEntriesPerPage = (value) => setPageSize(value);

  // Render the paginations
  const renderPagination = pageOptions.map((option) => (
    <MDPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </MDPagination>
  ));

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0
      ? gotoPage(0)
      : gotoPage(Number(value));

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) =>
    gotoPage(Number(value.value - 1));

  // Search input value state
  const [search, setSearch] = useState(globalFilter);

  // Search input state handle
  const onSearchChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 100);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  // Setting the entries starting point
  const entriesStart =
    rows.length === 0
      ? 0
      : pageIndex === 0
      ? pageIndex + 1
      : pageIndex * pageSize + 1;
  const [controller] = useMaterialUIController();
  const { transparentSidenav, whiteSidenav, darkMode, sidenavColor } =
    controller;
  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  // Setting the entries ending point

  let entriesEnd;
  if (pageIndex === 0) {
    entriesEnd = pageSize;
    if (entriesEnd >= rows.length) {
      entriesEnd = rows.length;
    } else {
      entriesEnd = pageSize;
    }
  } else if (pageIndex === pageOptions.length - 1) {
    entriesEnd = rows.length;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }

  return (
    <MDBox pt={4} pb={0}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            {Header && (
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
            )}
            <MDBox pt={0} pb={4}>
              {/* <Grid container py={1.5} px={3} spacing={2} >
                <Grid item xs={12} md={3} lg={3} xl={3}>
                  {entriesPerPage && (
                    <MDBox display="flex" alignItems="center">
                      <Autocomplete
                        disableClearable
                        value={pageSize.toString()}
                        options={entries}
                        onChange={(event, newValue) => {
                          setEntriesPerPage(parseInt(newValue, 10));
                        }}
                        size="small"

                        sx={{ width: "5rem" }}
                        renderInput={(params) => <MDInput  {...params} />}
                      />
                      <MDTypography
                        variant="caption"
                        color="dark"
                        sx={({ typography: { size, fontWeightBold } }) => ({
                          fontSize: size.xs,
                          fontWeight: fontWeightBold,
                          textTransform: "capitalize",
                          fontWeight: "400"

                        })}
                      >
                        &nbsp;&nbsp;Records Per Page
                      </MDTypography>
                    </MDBox>
                  )}
                </Grid>
                {addNew && canSearch && !selectedValue ? (
                  <Grid item xs={12} lg={4.7} xl={0}></Grid>
                ) : (
                  <Grid item xs={12} lg={0.8} xl={1}></Grid>
                )}

                {AddorSort && (
                  <>
                    {AddorSort}
                  </>
                )}

                {newSelectedValue && (


                  <Grid item xs={12} md={2} lg={3} xl={12} ml="auto">
                    {newSelectedValue}
                  </Grid>



                )}
                {selectedValue && (
                  <>
                    <Grid item xs={12} md={2} lg={3} xl={3} ml="auto">
                      {selectedValue}
                    </Grid>
                  </>
                )}

                {canSearch && (
                  <Grid item xs={12} md={2} lg={3} xl={3} ml={!selectedValue && "auto"}>
                    <MDBox>
                      <TextField
                        type="text"
                        label="Search..."
                        variant="outlined"
                        fullWidth
                        placeholder="Search..."
                        value={search}
                        size="medium"
                        onChange={({ currentTarget }) => {
                          setSearch(search);
                          onSearchChange(currentTarget.value);
                        }}
                      />
                    </MDBox>
                  </Grid>
                )}


                {addNew && (
                  <Grid item xs={12} md={2} lg={1.2} ml={!selectedValue && "0" && (!selectedValue && !canSearch) && "auto"}>
                    <Link to={link}>
                      <MDButton className="btn-block" color={link===""?"secondary":"success"}>Add New</MDButton>
                    </Link>
                  </Grid>
                )}
             
              </Grid> */}
              <TableContainer sx={{ boxShadow: "none" }}>
                {rows.length > 0 ? (
                  <Table
                    {...getTableProps()}
                    sx={{ width: "97%", margin: "auto" }}
                    className="table"
                  >
                    <MDBox component="thead">
                      {headerGroups.map((headerGroup) => (
                        <TableRow
                          {...headerGroup.getHeaderGroupProps()}
                          className={
                            darkMode ? "dark-table-head" : "light-table-head"
                          }
                        >
                          {headerGroup.headers.map((column) => (
                            <DataTableHeadCell
                              {...column.getHeaderProps(
                                isSorted && column.getSortByToggleProps()
                              )}
                              width={column.width ? column.width : "auto"}
                              align={column.align ? column.align : "left"}
                              sorted={setSortedValue(column)}
                            >
                              {/* <MDTypography
                                variant="strong"
                                sx={{ fontSize: "14px", textTransform: "capitalize"}}
                              > */}
                              {column.render("Header")}
                              {/* </MDTypography> */}
                            </DataTableHeadCell>
                          ))}
                        </TableRow>
                      ))}
                    </MDBox>

                    <TableBody {...getTableBodyProps()}>
                      {page.map((row, key) => {
                        prepareRow(row);
                        return (
                          <TableRow
                            {...row.getRowProps()}
                            className={
                              darkMode
                                ? "dark-table-striped"
                                : "light-table-striped"
                            }
                          >
                            {row.cells.map((cell) => (
                              <DataTableBodyCell
                                noBorder={
                                  noEndBorder && rows.length - 1 === key
                                }
                                align={
                                  cell.column.align ? cell.column.align : "left"
                                }
                                {...cell.getCellProps()}
                              >
                                {cell.render("Cell")}
                              </DataTableBodyCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                ) : (
                  <>
                    {" "}
                    <Table
                      {...getTableProps()}
                      sx={{ width: "97%", margin: "auto" }}
                      className="table"
                    >
                      <MDBox component="thead">
                        {headerGroups.map((headerGroup) => (
                          <TableRow {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <DataTableHeadCell
                                {...column.getHeaderProps(
                                  isSorted && column.getSortByToggleProps()
                                )}
                                width={column.width ? column.width : "auto"}
                                align={column.align ? column.align : "left"}
                                sorted={setSortedValue(column)}
                              >
                                {/* <MDTypography
                                  variant="strong"
                                  sx={{ fontSize: "14px", textTransform: "capitalize" }}
                                > */}
                                {column.render("Header")}
                                {/* </MDTypography> */}
                              </DataTableHeadCell>
                            ))}
                          </TableRow>
                        ))}
                      </MDBox>
                    </Table>
                    <Height val={10} />
                    <MDTypography
                      color="dark"
                      sx={({ typography: { size, fontWeightBold } }) => ({
                        fontSize: size.sm,
                        fontWeight: 400,
                        textTransform: "none",
                        textAlign: "center",
                      })}
                    >
                      No Record(s) Found
                    </MDTypography>
                  </>
                )}
              </TableContainer>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", sm: "center" }}
                p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
              >
                {showTotalEntries && (
                  <MDBox mb={{ xs: 3, sm: 0 }}>
                    <MDTypography
                      variant="button"
                      color="dark"
                      sx={({ typography: { size, fontWeightBold } }) => ({
                        fontSize: size.sm,
                        fontWeight: fontWeightBold,
                        textTransform: "capitalize",
                        fontWeight: "400",
                      })}
                    >
                      Showing <b>{entriesStart}</b> to <b>{entriesEnd}</b> of{" "}
                      <b>{rows.length}</b> Records
                      {/* Showing <b>{entriesStart}</b> to <b>{rows.length}</b> of <b>{entriesEnd}</b> Records */}
                    </MDTypography>
                  </MDBox>
                )}
                {pageOptions.length > 1 && (
                  <MDPagination
                    variant={
                      pagination.variant ? pagination.variant : "gradient"
                    }
                    color={pagination.color ? sidenavColor : sidenavColor}
                  >
                    {canPreviousPage && (
                      <MDPagination item onClick={() => previousPage()}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                      </MDPagination>
                    )}
                    {renderPagination.length > 6 ? (
                      <MDBox width="5rem" mx={1}>
                        <MDInput
                          inputProps={{
                            type: "number",
                            min: 1,
                            max: customizedPageOptions.length,
                          }}
                          value={customizedPageOptions[pageIndex]}
                          onChange={
                            (handleInputPagination, handleInputPaginationValue)
                          }
                        />
                      </MDBox>
                    ) : (
                      renderPagination
                    )}
                    {canNextPage && (
                      <MDPagination item onClick={() => nextPage()}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                      </MDPagination>
                    )}
                  </MDPagination>
                )}
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  // entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
  entriesPerPage: { defaultValue: 10, entries: [10] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
};

export default DataTable;
